export default __webpack_public_path__ + "static/media/Pierre_Auguste_Renoir_Two_sisters_30_x_40_cm.738e6619.jpg";